export default function PageHeader({ overline, title, description, actions, testId = "page-header" }) {
  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8" data-testid={testId}>
      <div>
        {overline && <p className="editorial-overline">{overline}</p>}
        <h1 className="font-serif text-3xl sm:text-4xl tracking-tight text-navy-900 mt-2">{title}</h1>
        {description && <p className="mt-2 text-muted-foreground max-w-2xl text-sm leading-relaxed">{description}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
